import { Component, HostListener, OnInit, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { TCCPCommonService } from "../../services/tccp-common.service";
import { TCCPLocalStorageService } from "../../services/tccp-local-storage.service";
import { environment } from "../../../../environments/environment";
import { PhoneManufacturerService } from "./phone-manufacturer.service";
import { LoaderService } from "../../loader/loader.service";
import { Utilities } from "../../utilities";
import { AdminService } from "src/modules/admin/admin.service";
import { BreadcrumbService } from "../breadcrumb/breadcrumb.service";
import * as _ from "lodash";
import { ChangeDetectorRef } from "@angular/core";

@Component({
  selector: "app-phone-manufacturer",
  templateUrl: "./phone-manufacturer.component.html",
  styleUrls: ["./phone-manufacturer.component.scss"],
})
export class PhoneManufacturerComponent implements OnInit {
  public phoneManufacturerList = [];
  public phoneModelList = [];
  public isSubmitted = false;
  public appName = environment.applicationName;
  public manufacturerForm: FormGroup;
  public searchForm: FormGroup;
  public vinError: boolean = false;
  public showVinInput: boolean = false;
  public showManufacturerModelSelection: boolean = false;
  public isSearchButtonSubmitted = false;
  public huConfigList: number[] = [];
  public selectedPhoneConfigId: any;
  public telematicsMPC = "";
  public windowWidth: any = window.innerWidth;
  public phoneHUConfigInfoList = [];
  public phoneModelWithHUCofigList = [];
  public isPhoneCompatabilityFromDirectLink = false;
  public vehicleVin = "";
  public vinInOtherDivisionError = false;
  public compatabilityNotAvailable = false;
  public screenWidth = 1025;
  public searchedVehicleModel = this.storageService.getVehicleModelName();
  public searchedVehicleYear = this.storageService.getVehicleYear().name;
  constructor(
    readonly router: Router,
    readonly fb: FormBuilder,
    private phoneManufacturerService: PhoneManufacturerService,
    public commonService: TCCPCommonService,
    private storageService: TCCPLocalStorageService,
    readonly loaderService: LoaderService,
    readonly renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    readonly adminService: AdminService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.isPhoneCompatabilityFromDirectLink =
      this.storageService.getPhoneCompatabilityDirectLink();
  }
  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  ngOnInit() {
    this.getScreenSize();
    this.vinError = false;
    this.breadcrumbService.showBreadcrumb.emit(true);
    this.commonService.setBackground(this.renderer, this.appName);
    this.searchForm = new FormGroup({
      vin: new FormControl("", [
        Validators.required,
        Validators.minLength(17),
        Validators.maxLength(17),
      ]),
    });
    this.manufacturerForm = this.fb.group({
      manufacturer: ["", Validators.required],
      phoneModel: [{ value: "", disabled: true }, Validators.required],
    });
    const storedVin = this.storageService.getVehicleVin().name;
    if (
      (storedVin || this.vehicleVin) &&
      !this.storageService.getBtSearchedByVin()
    ) {
      if (this.vehicleVin === "") {
        this.showVinInput = true;
        this.showManufacturerModelSelection = false;
      } else {
        this.vehicleVin = storedVin;
        this.searchForm.controls["vin"].setValue(storedVin);
        this.showVinInput = false;
        if (!this.showManufacturerModelSelection) {
          this.getPhoneManufaturerList(storedVin);
        }
        else {
        this.showManufacturerModelSelection = true;
        }
      }
    } else if (
      (storedVin || this.vehicleVin) &&
      this.storageService.getBtSearchedByVin()
    ) {
      this.showVinInput = false;
      if (!this.showManufacturerModelSelection) {
        this.getPhoneManufaturerList(storedVin);
      }
      this.showManufacturerModelSelection = true;
    } else if (
      (storedVin || this.vehicleVin || this.storageService.getBtVehicleVin()) &&
      this.storageService.getBackToPhoneSelection() &&
      this.storageService.getBtSearchedByVin()
    ) {
      this.showVinInput = false;
      this.storageService.setBackToPhoneSelection(false);
      this.getPhoneManufaturerList(this.storageService.getBtVehicleVin());
     
    } else {
      this.showVinInput = true;
    }
    this.breadcrumbService.showBreadcrumb.emit(true);
  }

  onVinKeyup(vin: string) {
    this.vinError = false;
    this.vinInOtherDivisionError = false;
    this.compatabilityNotAvailable = false;
  }

  onSearch() {
    this.loaderService.show();
    this.vinError = false;
    this.manufacturerForm.controls["manufacturer"].reset("");
    this.manufacturerForm.controls["phoneModel"].reset("");
    this.isSearchButtonSubmitted = true;
    const vin = this.searchForm.controls["vin"].value;
    this.commonService.getVehicleInfo(vin).subscribe(
      (vinData) => {
        if (vinData && vinData.summary) {
          let numMatches = 0;
          let foundLexusMatch = false;
          let foundToyotaMatch = false;
          let vinModel;
          let appName = this.storageService.appName;
          //toyota model and year check
          if (appName === "toyota") {
            if (vinData.summary.vehicleSummary.brand !== "TOY") {
              this.vinInOtherDivisionError = true;
            }
            vinModel = vinData.summary.vehicleSummary.modeldescription
              .replace(/-/g, "")
              .replace(/hv/gi, "Hybrid")
              .toUpperCase();
          } else {
            if (vinData.summary.vehicleSummary.brand !== "LEX") {
               this.vinInOtherDivisionError = true;
            }
            vinModel = vinData.summary.vehicleSummary.modeldescription
            .toUpperCase()
            .split(" ")
            .slice(0, 2)
            .join(" ");
          }
          this.commonService.getmodelName().subscribe((data) => {
            data.forEach((element, index) => {
              const modelCompare = element.model.toUpperCase().split(" ");

              if (appName === "toyota") {
                const matches = modelCompare.some((word) =>
                  vinModel.split(" ").includes(word)
                );
                if (matches > numMatches) {
                  numMatches = matches;

                  foundToyotaMatch = true;
                }
              } else {
                const lexMatches = modelCompare.some((word) =>
                  vinModel.includes(word)
                );
                if (lexMatches > 0) {
                  foundLexusMatch = true;
                }
              }
            });
              this.vehicleVin = vin;
              this.storageService.setBtVehicleVin(vin);
              this.storageService.setBtSearchedByVin(true);
              this.storageService.setModelCode(
                _.get(vinData, "summary.vehicleSummary.modelCode")
              );
              this.storageService.setBtModelCode(  _.get(vinData, "summary.vehicleSummary.modelCode"));
              this.storageService.setBtVehicleYear(
                _.get(vinData, "summary.vehicleSummary.modelYear"),
                null
              );
              this.storageService.setBtVehicleModel(
                _.get(vinData, "summary.vehicleSummary.modeldescription"),
                null
              );
              this.storageService.setBtVehicleModelName(vinModel);

              this.commonService.vinSummaryDetails = vinData;
              if (!this.vinInOtherDivisionError && (foundToyotaMatch || foundLexusMatch)) {
              this.getPhoneManufaturerList(vin);
              
              this.loaderService.show();
              }
          });
        } else {
          this.cdr.detectChanges();
          this.vinError = true;
          this.loaderService.hide();
        }
      },
      (error) => {
        this.loaderService.hide();
        this.vinError = true;
        this.cdr.detectChanges();
      }
    );
    this.loaderService.hide();
  }

  getPhoneManufaturerList(vin: string) {
    this.loaderService.show();
    const requestData = this.commonService.getBtPayload(this.huConfigList, vin);
    this.phoneManufacturerService
      .getHUConfigList(requestData)
      .subscribe((resultData) => {
        if (resultData.data.headUnits) {
          this.storageService.setHuPhoneConfigInfoList(resultData.data);
          resultData.data.headUnits.forEach((data, index) => {
            this.huConfigList.push(data.huConfigId);
            if (!_.isEmpty(vin)) {
              this.telematicsMPC = data.mpc;
              this.storageService.setTelematicsMPCCode(this.telematicsMPC);
            }
          });
          this.phoneManufacturerService
            .getManufaturerList(this.huConfigList)
            .subscribe(
              (data) => {
                if (data) {
                  if (data.messages) {
                    this.compatabilityNotAvailable = true;
                  } else {
                    this.phoneModelWithHUCofigList = data.data;

                    this.phoneManufacturerList =
                      data.data.headUnits[0].manufacturers;
                    this.cdr.detectChanges();
                    this.manufacturerForm.controls["phoneModel"].enable();
                  }
                }
              },
              (error) => {
                this.loaderService.hide();
              }
            );
          this.showVinInput = false;
          this.showManufacturerModelSelection = true;
          this.loaderService.hide();
        } else {
          this.compatabilityNotAvailable = true;
        }
      });
    this.storageService.setHeadUnitConfigList(this.huConfigList);
  }
  onManufaturerChange(event?) {
    this.loaderService.show();
    this.isSubmitted = false;
    this.phoneModelList = [];
    const manufaturerValue =
      event && event.target.value
        ? parseInt(event.target.value, 10)
        : event.target.value;

    this.phoneModelWithHUCofigList["headUnits"].forEach((data, index) => {
      data.manufacturers.forEach((manufacturersData) => {
        if (manufacturersData.manufacturerId === manufaturerValue) {
          this.storageService.setHeadUnitConfig(data.headUnitConfig);
        }
      });
    });

    const manufacturerList = Object.assign(
      [],
      this.phoneModelWithHUCofigList["headUnits"]
    );
    this.loaderService.hide();
    const phoneList = [];
    manufacturerList.forEach((manufactureData, i) => {
      manufactureData["manufacturers"].forEach((data, index) => {
        if (data.manufacturerId === manufaturerValue) {
          data["phones"].forEach((el, pindex) => {
            if (phoneList && phoneList.length > 0) {
              if (phoneList.indexOf(el.phoneModelName) === -1) {
                this.phoneModelList.push(el);
                phoneList.push(el.phoneModelName);
                this.manufacturerForm.controls["phoneModel"].enable();
              }
            } else {
              this.phoneModelList.push(el);
              phoneList.push(el.phoneModelName);
              this.manufacturerForm.controls["phoneModel"].enable();
            }
          });
        }
      });
    });
  }

  onPhoneModelChange(event?) {
    this.isSubmitted = false;
    const phoneModelValue =
      event && event.target.value
        ? parseInt(event.target.value, 10)
        : event.target.value;
    const manufacturerList = Object.assign(
      [],
      this.phoneModelWithHUCofigList["headUnits"]
    );
    this.phoneModelList.forEach((phoneData) => {
      if (phoneModelValue === phoneData.phoneConfigId) {
        this.selectedPhoneConfigId = phoneData;
      }
    });
    manufacturerList.forEach((manufactureData, i) => {
      manufactureData["manufacturers"].forEach((data, index) => {
        if (
          data.manufacturerId ==
          this.manufacturerForm.controls["manufacturer"].value
        ) {
          data["phones"].forEach((el, pindex) => {
            if (
              el["phoneModelName"] ===
              this.selectedPhoneConfigId["phoneModelName"]
            ) {
              const phoneJson = el;
              phoneJson["huConfigId"] = manufactureData.headUnitConfigId;
              this.phoneManufacturerService.selectedPhoneData.push(phoneJson);
            }
          });
        }
      });
    });
    this.getHeadUnitInfo();
    if (!this.vehicleVin) {
      if (
        this.storageService.getMPCCode() !==
          this.storageService.getTelematicsMPCCode() ||
        _.isEmpty(this.storageService.getMPCCode()) ||
        _.isEmpty(this.storageService.getTelematicsMPCCode())
      ) {
        this.storageService.setShowDisclaimer(true);
      }
    }
    this.storageService.setPhoneModel(this.selectedPhoneConfigId);
  }

  openCompatabiltyDashBoard() {
    this.isSubmitted = true;
    this.storageService.setPhoneCompatabilityDirectLink(false);
    this.showVinInput = false;
    this.showManufacturerModelSelection = false;
    if (this.manufacturerForm.valid) {
      this.storageService.setPhoneManufacturerValues(
        this.manufacturerForm.controls["manufacturer"].value,
        this.selectedPhoneConfigId.phoneConfigId
      );
      this.router.navigate([
        this.appName + "/bluetooth-compatability",
        this.manufacturerForm.controls["manufacturer"].value,
        this.selectedPhoneConfigId.phoneConfigId,
      ]);
    } else if (
      this.storageService.getBtPhoneManufacturer() &&
      this.storageService.getBtPhoneModel()
    ) {
      this.router.navigate([
        this.appName + "/bluetooth-compatability",
        this.storageService.getBtPhoneManufacturer,
        this.storageService.getBtPhoneModel,
      ]);
    }
    this.cdr.detectChanges();
  }
  public getHeadUnitInfo() {
    const requestData = this.commonService.getPayload(
      this.huConfigList,
      this.vehicleVin
    );
    this.phoneManufacturerService.getHUConfigList(requestData).subscribe(
      (resultData) => {
        if (resultData) {
          this.phoneHUConfigInfoList = resultData.data;
          this.storageService.setHuPhoneConfigInfoList(resultData.data);
          this.phoneHUConfigInfoList["headUnits"].forEach((huData, huIndex) => {
            this.phoneManufacturerService.selectedPhoneData.sort(function (
              a,
              b
            ) {
              return a.phoneConfigId - b.phoneConfigId;
            });
            this.phoneManufacturerService.selectedPhoneData.forEach(
              (phoneData) => {
                if (phoneData["huConfigId"] == huData.huConfigId) {
                  this.phoneHUConfigInfoList["headUnits"][huIndex][
                    "phoneOsVersion"
                  ] = phoneData["phoneOsVersion"];
                  this.phoneHUConfigInfoList["headUnits"][huIndex][
                    "phoneOsType"
                  ] = phoneData["phoneOsType"];
                  this.phoneHUConfigInfoList["headUnits"][huIndex][
                    "PhoneConfigId"
                  ] = phoneData["phoneConfigId"];
                }
              }
            );
          });
          this.phoneManufacturerService.selectedHUPhoneConfigData =
            this.phoneHUConfigInfoList;
        } else {
          this.phoneManufacturerService.selectedHUPhoneConfigData =
            this.phoneHUConfigInfoList;
        }
      },
      (error) => {}
    );
  }

  public backToBluetoothPage() {
    if (
      this.showManufacturerModelSelection &&
      this.storageService.getBtSearchedByVin()
    ) {
      this.showManufacturerModelSelection = false;
      this.showVinInput = true;
      this.storageService.setVehicleVin(null, null);
      this.vehicleVin = null;
      this.storageService.setBtVehicleVin(null);
      this.storageService.setBtSearchedByVin(false);
      this.searchForm.reset();
      this.vinError = false;
    } else {
      this.storageService.setBtVehicleVin("");

      this.router.navigate([
        this.appName + "/feature",
        Utilities.removeSpaceAndCamelCase(this.adminService.featureName),
        this.storageService.GetBluetoothIssueId().trim().trimLeft(),
      ]);
      this.storageService.setShowBluetoothComp(true);
    }
  }
}
